import { render, staticRenderFns } from "./ManageOrganizationStep.vue?vue&type=template&id=4736361d&scoped=true"
import script from "./ManageOrganizationStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageOrganizationStep.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ManageOrganizationStep.vue?vue&type=style&index=0&id=4736361d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4736361d",
  null
  
)

export default component.exports